export function textContrastChecker(r: number, g: number, b: number) {
  if (r * 0.299 + g * 0.587 + b * 0.114 > 147) {
    return '#000000';
  } else {
    return '#ffffff';
  }
}
